quoteModule.factory('quoteContractArchivalService', ['$http','AppSettings','commonRESTCallService', '$q',
    'contractInfoService',
    function ($http, appSettings, commonRESTCallService, $q, contractInfoService) {
        var quoteContractArchivalService = {};
        //Archive all contracts associated with a set of quotes
        quoteContractArchivalService.archiveContractsForQuote = function(quoteIds, encryptedQuoteIds){
            var deferred = $q.defer();

            if (quoteIds && quoteIds.length > 0) {
                //quoteIds assumed to be an array of integers
                //deleting all contracts for the quote
                var quotesToAttemptArchive = [];

                for(var i=0; i < quoteIds.length; i++){
                    var contracts = contractInfoService.contractsPerQuote[quoteIds[i]];
                    if (contracts && contractInfoService.contractInfo[contracts[0]].status.toUpperCase()!='OFFICIAL'){
                        quotesToAttemptArchive.push(encryptedQuoteIds[i]);
                    }
                }

                if (quotesToAttemptArchive.length > 0) {
                    var archiveUrl = appSettings.startSPANPlusSvcURL + "productcontracts/archive-by-quoteids/" + quotesToAttemptArchive.join(',');
                    commonRESTCallService.postToServer(
                        archiveUrl,
                        {}
                    )
                    .success(function contractNowArchived(data, status) {
                        quoteIds.forEach(function (id) {
                            //removing contract info in state
                            var urls = contractInfoService.contractsPerQuote[id];
                            if (contractInfoService.contractsPerQuote[id])
                                contractInfoService.contractsPerQuote[id] = undefined;
                            if (urls) {
                                urls.forEach(function (url) {
                                    if (contractInfoService.contractInfo[url])
                                        contractInfoService.contractInfo[url] = undefined;
                                });
                            }
                            quoteIds = null;
                            deferred.resolve(true);//done
                        })
                    })
                    .error(function (data, status) {
                        quoteIds = null;
                        deferred.reject(status + ' ' + JSON.stringify(data));
                    });
                }else{deferred.resolve(true);}
            }
            else
                deferred.resolve(true);
            return deferred.promise;
        }

        return quoteContractArchivalService;
    }]);
